"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = void 0;
exports.EVENTS = {
    SESSION_START: { type: "S", scope: "S", facet: "any" },
    SESSION_END: { type: "S", scope: "E", facet: "any" },
    SESSION_DETAILS: { type: "S", scope: "D", facet: "entitlement" },
    SESSION_FULL: { type: "S", scope: "F", facet: "any" },
    SESSION_PAGE: { type: "S", scope: "P", facet: "page" },
    IDENTIFY_USER: { type: "I", scope: "U", facet: "user" },
    PROJECT_START: { type: "P", scope: "S", facet: "content" },
    PROJECT_END: { type: "P", scope: "E", facet: "content" },
    PROJECT_FULL: { type: "P", scope: "F", facet: "content" },
    PROJECT_NAME: { type: "P", scope: "N", facet: "content" },
    DOCUMENT_START: { type: "D", scope: "S", facet: "content" },
    DOCUMENT_END: { type: "D", scope: "E", facet: "content" },
    DOCUMENT_FULL: { type: "D", scope: "F", facet: "content" },
    DOCUMENT_NAME: { type: "D", scope: "N", facet: "content" },
    DOCUMENT_TYPE: { type: "D", scope: "T", facet: "content" },
    CLICK_PAGE: { type: "C", scope: "P", facet: "component" },
    CLICK_COMPONENT: { type: "C", scope: "C", facet: "component" },
    CLICK_DISPLAY: { type: "C", scope: "D", facet: "component" },
    CLICK_OPERATION: { type: "C", scope: "O", facet: "component" },
    METRICS_COMPONENT: { type: "M", scope: "C", facet: "component" },
    METRICS_SESSION: { type: "M", scope: "S", facet: "component" },
    METRICS_SETTING: { type: "M", scope: "E", facet: "component" },
    GESTURE_COMPONENT: { type: "G", scope: "C", facet: "component" },
    HOVER_COMPONENT: { type: "H", scope: "C", facet: "component" },
    BACKGROUND_CALL: { type: "B", scope: "C", facet: "operation" },
    BACKGROUND_UPDATE: { type: "B", scope: "U", facet: "operation" },
    BACKGROUND_DOWNLOAD: { type: "B", scope: "D", facet: "operation" },
    BACKGROUND_INSTALL: { type: "B", scope: "I", facet: "operation" },
    BACKGROUND_JOB: { type: "B", scope: "J", facet: "operation" },
    USER_VIEW: { type: "V", scope: "U", facet: "component" },
    APPLICATION_VIEW: { type: "V", scope: "A", facet: "component" },
    OTHER_VIEW: { type: "V", scope: "O", facet: "component" },
};
